import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "hooks/useFetch";
import {toTurkishProperCase} from "utils/toTurkishProperCase";

const DynamicCityFilter = ({
    value,
    onChange,
    showLabel = true,
    valueKey = "_id",
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false,
    placeholder = "",
    ...props
}) => {
    const {t} = useTranslation();
    const stores = useStore();
    const [cityLoading, cityData] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.optionStore.getCityList.bind(null, {
            limit: 1000,
            sort: "name"
        })
    });

    return (
        <React.Fragment>
            {showLabel && <h5>{t("fields.city", {ns: "common"})}</h5>}
            <SelectField
                showSearch
                value={value}
                data-testid="city"
                mode={mode}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
                placeholder={placeholder}
                loading={cityLoading}
                filterOption={(input, option) => {
                    return (
                        option?.["data-cityname"]
                            ?.toLocaleLowerCase("TR-tr")
                            ?.indexOf(input.toLocaleLowerCase("TR-tr")) >= 0
                    );
                }}
                {...props}
            >
                {arrayAlphabeticalSort([...(cityData?.data || [])]).map((city, i) => (
                    <SelectField.Option
                        data-testid="city_option"
                        key={i}
                        data-cityname={city.name}
                        value={city?.[valueKey]}
                    >
                        {toTurkishProperCase(city.name)}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default DynamicCityFilter;
